/* eslint-disable @typescript-eslint/no-unsafe-function-type */
import { isFalsy } from './Helper';
import { CometChatCallsException } from './models/CometChatCallsException';
import { type ICallEventsData } from './types/callEvents';

interface IOngoingCallListener {
  // onYouLeft: (test: any[]) => void;
  // onYouJoined: (test: any[]) => void;
  onUserJoined: (user: Partial<ICallEventsData['onUserJoined']>) => void;
  onUserLeft: (user: Partial<ICallEventsData['onUserJoined']>) => void;
  onUserListUpdated: (
    userList: Partial<ICallEventsData['onUserListUpdated']>,
  ) => void;
  onMediaDeviceListUpdated: (
    devices: Partial<ICallEventsData['onMediaDeviceListUpdated']>,
  ) => void;
  onRecordingStarted: (
    event: Partial<ICallEventsData['onRecordingStarted']>,
  ) => void;
  onRecordingStopped: () => void;
  onScreenShareStarted: () => void;
  onScreenShareStopped: () => void;
  onUserMuted: (event: Partial<ICallEventsData['onUserMuted']>) => void;
  onUserUnMuted: (event: Partial<ICallEventsData['onUserUnMuted']>) => void;
  onCallSwitchedToVideo: (
    event: Partial<ICallEventsData['onCallSwitchedToVideo']>,
  ) => void;
  onCallEnded: () => void;
  onSessionTimeout: () => void;
  onCallEndButtonPressed: () => void;
  onError: (error: CometChatCallsException) => void;
}

export class OngoingCallListener {
  /**
   * @internal
   */
  onYouLeft?: Function;

  /**
   * @internal
   */
  onYouJoined?: Function;

  /**
   * This event is triggered when a user joins the call.
   */
  onUserJoined?: IOngoingCallListener['onUserJoined'];

  /**
   * This event is triggered when a user leaves the call.
   */
  onUserLeft?: IOngoingCallListener['onUserLeft'];

  /**
   * This event is triggered when the participant list of the call changes.
   */
  onUserListUpdated?: IOngoingCallListener['onUserListUpdated'];

  /**
   * This event is triggered when the media device list changes.
   */
  onMediaDeviceListUpdated?: IOngoingCallListener['onMediaDeviceListUpdated'];

  /**
   * This event is triggered when someone starts recording the call.
   */
  onRecordingStarted?: IOngoingCallListener['onRecordingStarted'];

  /**
   * This event is triggered when someone stops recording the call.
   */
  onRecordingStopped?: IOngoingCallListener['onRecordingStopped'];

  /**
   * This event is triggered when someone starts sharing their screen in the call.
   */
  onScreenShareStarted?: IOngoingCallListener['onScreenShareStarted'];

  /**
   * This event is triggered when someone stops sharing their screen in the call.
   */
  onScreenShareStopped?: IOngoingCallListener['onScreenShareStopped'];

  /**
   * This event is triggered when a user is muted.
   */
  onUserMuted?: IOngoingCallListener['onUserMuted'];

  /**
   * This event is triggered when a user is unmuted.
   */
  onUserUnMuted?: IOngoingCallListener['onUserUnMuted'];

  /**
   * This event is triggered when an audio call is switched to a video call.
   */
  onCallSwitchedToVideo?: IOngoingCallListener['onCallSwitchedToVideo'];

  /**
   * This event is triggered when the call is ended.
   */
  onCallEnded?: IOngoingCallListener['onCallEnded'];

  /**
   * This event is triggered when the call is ended due to session timeout.
   */
  onSessionTimeout?: IOngoingCallListener['onSessionTimeout'];

  /**
   * This event is triggered when an error occurs.
   */
  onError?: IOngoingCallListener['onError'];

  /**
   * This event is triggered when user presses end call button.
   */
  onCallEndButtonPressed?: IOngoingCallListener['onCallEndButtonPressed'];

  constructor(eventObj: Partial<IOngoingCallListener>) {
    // if (!isFalsy(eventObj["onYouLeft"])) this.onYouLeft = eventObj["onYouLeft"];
    // if (!isFalsy(eventObj["onYouJoined"])) this.onYouJoined = eventObj["onYouJoined"];
    if (!isFalsy(eventObj['onUserJoined']))
      this.onUserJoined = eventObj['onUserJoined'];
    if (!isFalsy(eventObj['onUserLeft']))
      this.onUserLeft = eventObj['onUserLeft'];
    if (!isFalsy(eventObj['onUserListUpdated']))
      this.onUserListUpdated = eventObj['onUserListUpdated'];
    if (!isFalsy(eventObj['onMediaDeviceListUpdated']))
      this.onMediaDeviceListUpdated = eventObj['onMediaDeviceListUpdated'];
    if (!isFalsy(eventObj['onRecordingStarted']))
      this.onRecordingStarted = eventObj['onRecordingStarted'];
    if (!isFalsy(eventObj['onRecordingStopped']))
      this.onRecordingStopped = eventObj['onRecordingStopped'];
    if (!isFalsy(eventObj['onScreenShareStarted']))
      this.onScreenShareStarted = eventObj['onScreenShareStarted'];
    if (!isFalsy(eventObj['onScreenShareStopped']))
      this.onScreenShareStopped = eventObj['onScreenShareStopped'];
    if (!isFalsy(eventObj['onUserMuted']))
      this.onUserMuted = eventObj['onUserMuted'];
    if (!isFalsy(eventObj['onUserUnMuted']))
      this.onUserUnMuted = eventObj['onUserUnMuted'];
    if (!isFalsy(eventObj['onCallSwitchedToVideo']))
      this.onCallSwitchedToVideo = eventObj['onCallSwitchedToVideo'];
    if (!isFalsy(eventObj['onCallEnded']))
      this.onCallEnded = eventObj['onCallEnded'];
    if (!isFalsy(eventObj['onSessionTimeout']))
      this.onSessionTimeout = eventObj['onSessionTimeout'];
    if (!isFalsy(eventObj['onError'])) this.onError = eventObj['onError'];
    if (!isFalsy(eventObj['onCallEndButtonPressed']))
      this.onCallEndButtonPressed = eventObj['onCallEndButtonPressed'];
  }
}
